import { PortfolioUtilities as portfolioUtilities } from '@common/portfolio.utilities';
import { PortfolioRepo as portfolioRepo } from '@services/portfolio.repo';
import * as _ from 'lodash';
import { AssetClassColourArray } from '@common/enums/AssetClassType';
import { isNullOrUndefined } from 'util';
import { AggregatePortfolioItem } from '@models/portfolio/aggregatePortfolioItem';

class PortfolioManagementSummaryController implements angular.IOnInit {

  public selectedPortfolioIds: Array<number>;
  public selectedCurrency: string;

  public performance: any;

  public regionalSummary: any[]
  public assetClass: AggregatePortfolioItem[];
  public geographies: AggregatePortfolioItem[];
  public sectors: AggregatePortfolioItem[];
  public currencies: AggregatePortfolioItem[];

  // colour variables:
  public confidentGrey = '#646363';
  public confidentRedTint = '#ed432c';

  // colour array
  public colourArray = AssetClassColourArray;
  public regionalColours = ['#646363', '#ed432c']

  public isLoading: boolean = false;

  public selectedLocality;

  /** @ngInject */
  constructor(private portfolioRepo: portfolioRepo, private $scope: angular.IScope, private portfolioUtilities: portfolioUtilities, private notifyjs: any) { }

  $onInit() { }

  // trigger updates to portfolio summary based on the selected portfolioIds or currency
  $onChanges(changes) {
    if (changes.selectedPortfolioIds || changes.selectedCurrency || changes.selectedLocality) {
      this.updateData()
      this.updatePerformanceData()
    }
  }

  updateData() {
    // Guard against empty or invalid portfolio IDs to prevent backend errors
    if (!this.selectedPortfolioIds || this.selectedPortfolioIds.length === 0) {
      this.isLoading = false;
      this.assetClass = [];
      this.geographies = [];
      this.sectors = [];
      this.currencies = [];
      this.regionalSummary = [];
      return;
    }

    this.isLoading = true;
    const localityPromise = this.portfolioRepo.getPortfolioAggregatesByLocality(null, this.selectedCurrency, this.selectedPortfolioIds);
    const assetClassPromise = this.portfolioRepo.getPortfolioAggregatesByAssetClasses(null, this.selectedCurrency, this.selectedLocality, this.selectedPortfolioIds);
    const geographyPromise = this.portfolioRepo.getPortfolioAggregatesByGeography(this.selectedCurrency, this.selectedPortfolioIds,null, this.selectedLocality);
    const sectorPromise = this.portfolioRepo.getPortfolioAggregatesBySector(this.selectedCurrency, this.selectedPortfolioIds , null,this.selectedLocality);
    const currencyPromise = this.portfolioRepo.getPortfolioAggregatesByCurrency(this.selectedCurrency, this.selectedPortfolioIds , null,this.selectedLocality);

    Promise.all([localityPromise, assetClassPromise, geographyPromise, sectorPromise, currencyPromise])
      .then(([localityResp, assetClassResp, geographyResp, sectorResp, currencyResp]) => {

        this.createRegionalSummary(localityResp);

        this.assetClass = assetClassResp;

        geographyResp.sort((x, y) => y.total - x.total);
        this.geographies = geographyResp;

        sectorResp.sort((x, y) => y.total - x.total);
        this.sectors = sectorResp;

        currencyResp.sort((x, y) => y.total - x.total);
        this.currencies = currencyResp;

      })
      .then(() => this.isLoading = false); // In place of the finally as Promise.all doesnt seem to have one
  }

  private createRegionalSummary(localityResp: AggregatePortfolioItem[]) {
    this.regionalSummary = localityResp.map(portfolio => {
      return {
        name: portfolio.name == 'Local' ? 'Mauritius' : portfolio.name,
        total: portfolio.total,
        color: portfolio.name == 'Local' ? this.confidentGrey : this.confidentRedTint
      };
    });
  }

  public updatePerformanceData() {
    // Guard against empty or invalid portfolio IDs to prevent backend errors
    if (!this.selectedPortfolioIds || this.selectedPortfolioIds.length === 0) {
      this.isLoading = false;
      this.performance = null;
      return;
    }

    this.isLoading = true;
    this.portfolioRepo.getPortfolioPerformance(this.selectedCurrency, this.selectedPortfolioIds)
      .then((val) => this.performance = val.data)
      .finally(() => this.isLoading = false);
  }

  public getPercentageFromDecimal(decimal: number) {
    return decimal * 100;
  }

  public formatCurrency() {
    if (this.isLoading) {
      return "";
    }

    return this.portfolioUtilities.formatCurrency(this.selectedCurrency);
  }

  public getAssetClassTotal(assetClassTotals, assetClassName) {
    let assetClassTotal = assetClassTotals.find(assetClass => assetClass.name == assetClassName)
    return isNullOrUndefined(assetClassTotal) ? 0 : assetClassTotal
  }

  public getPercentage(value: number, total: number) {
    return (value / total) * 100;
  }

  public tranc(value) {
    return Math.trunc(value);
  }

  public commaSep(value) {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  public formatName(name: string) {
    return _.startCase(name);
  }
}

export const portfolioManagementSummary: angular.IComponentOptions = {
  template: require('./portfolioadmin.summary.html'),
  controller: PortfolioManagementSummaryController,
  bindings: {
    clientId: "<",
    selectedPortfolioIds: "<",
    selectedCurrency: "<",
    clientPortfolios: "<",
    selectedLocality : "<"
  }
}



// WEBPACK FOOTER //
// ./src/app/portfolioadmin/summary/portfolioadmin.summary.ts